export default {
	namespaced: true,
	state: {
		filters: [
			{
				id: 0,
				name: 'hidden'
			},
			{
				id: 1,
				name: 'commercial'
			},
			{
				id: 2,
				name: 'documentary'
			},
			{
				id: 3,
				name: 'music'
			},
			{
				id: 4,
				name: 'narrative'
			}
		],
		isReady: false
	},
	getters: {
		filters: (state) => state.filters,
		isReady: (state) => state.isReady
	},
	mutations: {
		ready: (state, payload) => (state.isReady = payload)
	},
	actions: {
		ready: ({ commit }, payload) => commit('ready', payload)
	}
}
